import React, { useEffect } from "react";
import { setFeatureNotAvailOnWeb, setShowCustomPopup } from "../../action/action";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { setGoHome } from "../action/homeAction";
import { closeOrderPopUp } from "../action/hCommerce2";
import { AesUtil } from "../../JS/AesUtil";
import { globalIV, globalSalt } from "../../config/constant";

const NotAvailWebPopup = (props) => {

    const { t } = props
    const aesUtil = new AesUtil(128, 1000);
    const checkInGuestInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))
    let room = localStorage.getItem("room")

    const openApp = () => {

        if(props.mobileDeepLink && props.mobileDeepLink != ""){

            if(room && room != "null"){

                const loginAuthTokenData = {
                    confirmationNumber: checkInGuestInfo[0].reservationNumber,
                    lastName: checkInGuestInfo[0].guestProfile.lastName,
                    roomNumber: room
                }
                let loginAuthToken = encodeURIComponent(aesUtil.encrypt( globalSalt, globalIV, "1234567891234567", JSON.stringify(loginAuthTokenData)));
                

                let deepLinkUrl = new URL(props.mobileDeepLink);
                if (deepLinkUrl.search) {
                    deepLinkUrl.search += '&' + `loginAuthToken=${loginAuthToken}`;
                } else {
                    deepLinkUrl.search = '?' + `loginAuthToken=${loginAuthToken}`;
                }

                window.location.href = deepLinkUrl.href;
            } else {
                window.location.href = props.mobileDeepLink;
            }
        } else {
            props.closeOrderPopUp(true,t('featureNotSupportedOnWeb.noLinkFound'), "", true)
        }

        props.setFeatureNotAvailOnWeb(false);
        props.setGoHome(true);
    }

    useEffect(()=>{

        props.setShowCustomPopup(true,{
            htmlTagId:"not-supported",
            title: props.featureNotAvailOnWeb.featureName,
            subtitle:"",
            heading:t('featureNotSupportedOnWeb.heading_popup'),
            subHeading:t('featureNotSupportedOnWeb.message'),
            primaryButtonText:t('featureNotSupportedOnWeb.openApp'),
            secondaryButtonText:t('featureNotSupportedOnWeb.close'),
            secondaryButtonStyleIsUnderline:false,
            primaryOnClick:()=>{props.setShowCustomPopup(false,{}); openApp();},
            secondaryOnClick:()=>{props.setShowCustomPopup(false,{}); props.setFeatureNotAvailOnWeb(false); props.setGoHome(true);},
            closeOnClick:()=>{props.setShowCustomPopup(false,{}); props.setFeatureNotAvailOnWeb(false); props.setGoHome(true);}
})  

    },[])

    return (
        <></>
    )
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
        mobileDeepLink: state.store2.mobileDeepLink,
        featureNotAvailOnWeb: state.store2.featureNotAvailOnWeb,
    }
}

export default connect(
    mapStateToProps, { setFeatureNotAvailOnWeb, setShowCustomPopup, setGoHome, closeOrderPopUp }
)(withTranslation('translations')(NotAvailWebPopup));